import React, { useEffect, useState } from "react";
import { Container, Dropdown, Nav, NavDropdown, Navbar } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";

// css
import "./Header.scss";

// comp
import Workbooks from "./Workbooks";

// img
import logo from "../../Assets/images/logo.png";
import user from "../../Assets/images/dummyUser.png";
import UploadStockPopup from "../Modals/uploadStockPopup";
import { useFetchUserProfileQuery } from "store/services/user.service";

const Header = () => {
  const { data: userProfile } = useFetchUserProfileQuery(undefined);
  const [stockData, setStockData] = useState("");
  const [profileImage, setProfileImage] = useState(user);

  useEffect(() => {
    if (userProfile?.profileImage) {
      setProfileImage(userProfile.profileImage);
    }
  }, [userProfile]);

  const handleStockData = (evt) => {
    evt.preventDefault();
    setStockData(!stockData);
  };

  return (
    <>
      <UploadStockPopup stockData={stockData} setStockData={setStockData} />

      <header
        className="siteHeader position-relative pt-lg-4 pt-sm-3 position-absolute w-100"
        style={{ zIndex: 99 }}
      >
        <Container>
          <Navbar expand="lg" className="px-lg-5 px-sm-3 pb-2 pt-1">
            <Navbar.Brand href="#" className="position-absolute mx-auto">
              <img src={logo} alt="" className="img-fluid" />
            </Navbar.Brand>

            <Navbar.Toggle aria-controls="navbarScroll" />

            <Navbar.Collapse id="navbarScroll">
              <Nav
                className="me-auto my-2 position-relative my-lg-0 w-100 d-flex align-items-center justify-content-between gap-10"
                navbarScroll
              >
                <div className="left ">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center linkWrpper">
                    <li className="">
                      <NavLink
                        to="/home"
                        className={
                          "position-relative fw-sbold navlink px-0 py-1"
                        }
                      >
                        Home
                      </NavLink>
                    </li>

                    <li className="">
                      <NavLink
                        onClick={handleStockData}
                        to="/workbook"
                        className={
                          "position-relative fw-sbold navlink px-0 py-1 animateLink"
                        }
                      >
                        <span className="icndot position-absolute">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="6"
                            height="6"
                            viewBox="0 0 6 6"
                            fill="none"
                          >
                            <circle
                              cx="3"
                              cy="3"
                              r="3"
                              fill="url(#paint0_linear_38_1223)"
                            />
                            <defs>
                              <linearGradient
                                id="paint0_linear_38_1223"
                                x1="3"
                                y1="0"
                                x2="3"
                                y2="6"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3A674A" />
                                <stop offset="1" stopColor="#0C3D1D" />
                              </linearGradient>
                            </defs>
                          </svg>
                        </span>
                        Import Data
                      </NavLink>
                    </li>

                    <li className="">
                      <NavDropdown
                        title="Workbook"
                        className="workbook"
                        id="basic-nav-dropdown"
                      >
                        <div className="top d-flex align-items-center border-bottom pb-2">
                          <span className="icn me-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="20"
                              viewBox="0 0 18 20"
                              fill="none"
                            >
                              <path
                                opacity="0.4"
                                d="M12.8418 0.833496H5.15917C2.3725 0.833496 0.75 2.46516 0.75 5.261V14.7302C0.75 17.5718 2.3725 19.1668 5.15917 19.1668H12.8418C15.6733 19.1668 17.25 17.5718 17.25 14.7302V5.261C17.25 2.46516 15.6733 0.833496 12.8418 0.833496Z"
                                fill="url(#paint0_linear_0_9182)"
                              />
                              <path
                                d="M5.40687 13.4287H12.5935C12.9593 13.4654 13.2352 13.777 13.2352 14.1529C13.2352 14.5186 12.9593 14.8312 12.5935 14.8679H5.40687C5.13187 14.9045 4.86604 14.767 4.71937 14.5379C4.57271 14.2995 4.57271 13.997 4.71937 13.7679C4.86604 13.5295 5.13187 13.4012 5.40687 13.4287ZM12.5935 9.24777C12.9877 9.24777 13.3085 9.56952 13.3085 9.96369C13.3085 10.3579 12.9877 10.6787 12.5935 10.6787H5.40687C5.01179 10.6787 4.69188 10.3579 4.69188 9.96369C4.69188 9.56952 5.01179 9.24777 5.40687 9.24777H12.5935ZM8.14679 5.09619C8.54188 5.09619 8.86271 5.41702 8.86271 5.81027C8.86271 6.21452 8.54188 6.53536 8.14679 6.53536H5.40687C5.01179 6.53536 4.69188 6.21452 4.69188 5.82036C4.69188 5.42619 5.01179 5.10536 5.40687 5.10536V5.09619H8.14679Z"
                                fill="url(#paint1_linear_0_9182)"
                              />
                              <defs>
                                <linearGradient
                                  id="paint0_linear_0_9182"
                                  x1="9"
                                  y1="0.833496"
                                  x2="9"
                                  y2="19.1668"
                                  gradientUnits="userSpaceOnUse"
                                >
                                  <stop stopColor="#3A674A" />
                                  <stop offset="1" stopColor="#0C3D1D" />
                                </linearGradient>
                                <linearGradient
                                  id="paint1_linear_0_9182"
                                  x1="8.95896"
                                  y1="5.09619"
                                  x2="8.95896"
                                  y2="14.8737"
                                  gradientUnits="userSpaceOnUse"
                                >
                                  <stop stopColor="#3A674A" />
                                  <stop offset="1" stopColor="#0C3D1D" />
                                </linearGradient>
                              </defs>
                            </svg>
                          </span>

                          <p className="m-0 themeClr">Recent Workbooks</p>
                        </div>

                        <Workbooks />
                      </NavDropdown>
                    </li>
                  </ul>
                </div>

                <div className="right ">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center linkWrpper">
                    <li className="">
                      {/* <NavLink
                        to="/contact"
                        className={
                          "position-relative fw-sbold navlink px-0 py-1"
                        }
                      >
                        Contact Us
                      </NavLink> */}

                       <a
                        href="https://www.tickerlines.com/contact"
                        className="position-relative fw-sbold navlink px-0 py-1"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Contact Us
                      </a>
                    </li>
                    {/* {userProfile?.isSubscribed === true ? null : ( */}
                      <li className="">
                        <NavLink
                          to="/subscription"
                          className={
                            "position-relative fw-sbold navlink px-0 py-1"
                          }
                        >
                          Subscription
                        </NavLink>
                      </li>
                    {/* )} */}
                    <li className="">
                      <NavLink
                        to="/my-profile"
                        className={
                          "position-relative fw-sbold navlink p-1 profileLink rounded-pill d-flex align-items-center"
                        }
                      >
                        <div className="imgWrp me-2 rounded-circle ">
                          {userProfile?.profileImage ? (
                            <img
                              src={profileImage}
                              alt=""
                              className="prof-img"
                              height={35}
                              width={35}
                            />
                          ) : (
                            <img src={user} alt="" className="img-fluid" />
                          )}
                        </div>

                        <div className="content pe-3">
                          <p className="m-0 fw-sbold themeClr">
                            {userProfile?.name}
                          </p>
                          <span className="m-0 fw-normal">
                            {userProfile?.email}
                          </span>
                        </div>
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </Container>
      </header>
    </>
  );
};

export default Header;
